{
    "webshop_offer_voucher_correctCode": "A megadott kód helyes",
    "webShop_howToFindId_desc": "A személyi azonosítódat a játékosprofilodban találhatod meg és másolhatod ki.",
    "webShop_howToFindId_link": "Hol található a személyes azonosítóm?",
    "webshop_offer_voucher_codeIsIncorrect": "Helytelen kód",
    "webshop_offer_voucher_enterYourCode": "Add meg a személyes azonosítódat",
    "webShop_unexpectedError_desc": "Váratlan hiba történt, próbáld újra később.",
    "webShop_accountBanned_desc": "Fiók kitiltva!",
    "webshop_confirm": "OK",
    "webshop_termsConditions_1": "Felhasználási feltételek",
    "webshop_purchase_privacyPolicy": "Adatvédelmi szabályzat",
    "webshop_legal_1": "Jogi",
    "webshop_support_1": "Ügyfélszolgálat",
    "mbs_access_welcome_desc": "Üdv, {0}!",
    "btn_login": "Bejelentkezés",
    "mbs_access_error_sessionExpired_desc": "A munkamenet lejárt. Add meg manuálisan a fiókazonosítódat."
}
